import React, { PureComponent, Fragment } from 'react';

import ReactEcharts from "echarts-for-react";


export default class ContractNurseryChart extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            year: this.props.year,
        }
    }

    componentWillReceiveProps = (nextProps) => {

        if (nextProps.data === undefined || nextProps.data.length < 1)
            return

        var chartData = this.parseData(nextProps.data);

        this.setState({
            yearList: chartData.yearList,
            nurseryList: chartData.nurseryList,
            daycareList: chartData.daycareList,
            nullList: chartData.nullList,
            countryRateList: chartData.countryRateList,

            maxValue: chartData.maxValue
        })
    }

    parseData = (data) => {
        var chartData = []
        for (var key in data) {
            chartData.push(Object.assign({ name: key }, data[key]))
        }

        var maxValue = 4000

        var yearList = []
        var nurseryList = []
        var daycareList = []
        var nullList = []
        var countryRateList = []

        chartData.forEach(year => {
            yearList.push(year.name)
            nurseryList.push(year.nursery_count)
            daycareList.push(year.daycare_count)
            nullList.push(year.null_count)
            countryRateList.push(year.total_rate)

            if (maxValue < (year.total_count)) {
                maxValue = year.total_count
            }
        });

        maxValue = Math.ceil(maxValue / 1000) * 1000;


        return {
            yearList: yearList,
            nurseryList: nurseryList,
            daycareList: daycareList,
            nullList: nullList,
            countryRateList: countryRateList,

            maxValue: maxValue
        }
    }

    _onEvent = {
        'click': (params) => {
            this.props.yearChangeHandler(params.name);
        }
    }


    render() {

        if (this.state.yearList == null) {
            return (
                <div className="card border-top border-3 border-top-primary">
                    <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                        <h5 className="card-header-title">계약</h5>
                    </div>
                    <div className="card-body" style={{ height: this.props.height + "px", textAlign: "center", paddingTop: "50px" }}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </div>
            )
        } else if (this.state.yearList.length === 0) {
            return (
                <div className="card border-top border-3 border-top-primary">
                    <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                        <h5 className="card-header-title">계약</h5>
                    </div>
                    <div className="card-body" style={{ height: this.props.height + "px", textAlign: "center", paddingTop: "50px" }}>
                        No Data
                    </div>
                </div>
            )
        } else {
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    data: ['유치원', '어린이집', '기타', '전국 계약률']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.state.yearList,
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '계약(원)',
                        min: 0,
                        max: this.state.maxValue,
                        interval: this.state.maxValue / 5,
                        axisLabel: {
                            formatter: (param) => {
                                return param.toLocaleString();
                            }
                        }
                    },
                    {
                        type: 'value',
                        name: '전국 계약률(%)',
                        min: 0,
                        max: 10,
                        interval: 2,
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }
                ],
                series: [
                    {
                        name: '유치원',
                        type: 'bar',
                        stack: 'one',
                        data: this.state.nurseryList
                    },
                    {
                        name: '어린이집',
                        type: 'bar',
                        stack: 'one',
                        data: this.state.daycareList
                    },
                    {
                        name: '기타',
                        type: 'bar',
                        stack: 'one',
                        data: this.state.nullList
                    },
                    {
                        name: '전국 계약률',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.state.countryRateList
                    }
                ]
            }

            return (
                <div className="card border-top border-3 border-top-primary">
                    <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                        <h5 className="card-header-title">계약</h5>
                    </div>
                    <div className="card-body" style={{ height: this.props.height + "px" }}>
                        <ReactEcharts theme="macarons" option={option} onEvents={this._onEvent} />
                    </div>
                </div>
            )
        }
    }
}
